<template>
  <div class="note-list">
    <notes-item
      v-for="note in notes"
      :note="note"
      :key="note.id"
      @editNote="editNote"
      @deleteNote="deleteNote"
    />
  </div>
</template>

<script>
import NotesItem from "./NotesItem.vue";

export default {
  name: "NotesList",

  props: {
    notes: {
      type: Array,
      default: () => []
    }
  },

  components: {
    NotesItem
  },

  methods: {
    editNote(note) {
      this.$emit("editNote", note);
    },
    deleteNote(note) {
      this.$emit("deleteNote", note);
    }
  }
};
</script>

<style lang="scss"></style>
